import React, { useEffect, useRef } from "react";
import raf from "raf";

export const VideoContext = React.createContext();

export const Video = ({ onFrame, onVideo, ...rest }) => {
  const videoRef = useRef(null);
  const handledVideoRef = useRef(false);

  useEffect(() => {
    let handle;
    let lastTime;

    const loop = () => {
      handle = raf(loop);
      if (!videoRef.current) return;

      if (!handledVideoRef.current && videoRef.current.videoWidth) {
        onVideo(videoRef.current);
        handledVideoRef.current = true;
      }

      const currentTime = videoRef.current.currentTime;

      // Optimization that only call onFrame if time changes
      if (currentTime !== lastTime) {
        lastTime = currentTime;
        onFrame(currentTime);
      }
    };
    handle = raf(loop);

    return () => raf.cancel(handle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onFrame, videoRef]);

  return (
    <VideoContext.Provider value={videoRef}>
      <video
        style={{ width: "100%", minHeight: "100vh" }}
        {...rest}
        ref={videoRef}
      />
    </VideoContext.Provider>
  );
};
